import React from "react";

export default function Loading({ message = "Querying Athena..." }: { message?: string }) {
  return (
    <div className="fixed inset-0 bg-[#0f1117]/80 backdrop-blur-sm flex flex-col items-center justify-center z-[1000]">
      <div className="w-10 h-10 border-3 border-[#2a2d3e] border-t-blue-500 rounded-full animate-spin mb-4" />
      <p className="text-gray-400 text-sm">{message}</p>
    </div>
  );
}
